// Catalogo unico de tipos de grafico, compartilhado entre o Construtor (TI) e o Dashboard.
// `needs` lista os campos que o tipo exige na UI: x, y, serie, valor, size.
// O renderizador real fica em components/Chart.jsx (SVG a mao).

export const CHART_TIPOS = [
    { id: 'bar',         label: 'Barras',              needs: ['x', 'y'] },
    { id: 'barh',        label: 'Barras horizontais',  needs: ['x', 'y'] },
    { id: 'bar-stacked', label: 'Barras empilhadas',   needs: ['x', 'y', 'serie'] },
    { id: 'bar-grouped', label: 'Barras agrupadas',    needs: ['x', 'y', 'serie'] },
    { id: 'line',        label: 'Linha',               needs: ['x', 'y'] },
    { id: 'area',        label: 'Area',                needs: ['x', 'y'] },
    { id: 'pie',         label: 'Pizza / Rosca',       needs: ['x', 'y'] },
    { id: 'scatter',     label: 'Dispersao',           needs: ['x', 'y'] },
    { id: 'bubble',      label: 'Bolhas',              needs: ['x', 'y', 'size'] },
    { id: 'radar',       label: 'Radar',               needs: ['x', 'y'] },
    { id: 'heatmap',     label: 'Mapa de calor',       needs: ['x', 'y', 'valor'] },
    { id: 'treemap',     label: 'Treemap',             needs: ['x', 'y'] },
    { id: 'histogram',   label: 'Histograma',          needs: ['x'] },
    { id: 'boxplot',     label: 'Boxplot',             needs: ['x', 'y'] },
    { id: 'kpi',         label: 'KPI',                 needs: ['y'] }
];

export const FIELD_LABELS = {
    x:     'Coluna X',
    y:     'Coluna Y',
    serie: 'Serie (cor)',
    valor: 'Valor',
    size:  'Tamanho (bolha)'
};

// label especifico do campo Y por tipo (ex.: KPI soma a coluna)
export function labelCampo(tipo, campo) {
    if (campo === 'y' && tipo === 'kpi') return 'Coluna para somar/contar';
    if (campo === 'y' && tipo === 'histogram') return 'Coluna (opcional)';
    if (campo === 'x' && tipo === 'histogram') return 'Coluna numerica (bins)';
    return FIELD_LABELS[campo] || campo;
}

export function camposDoTipo(tipo) {
    const t = CHART_TIPOS.find(c => c.id === tipo) || CHART_TIPOS.find(c => c.id === (tipo === 'donut' ? 'pie' : tipo));
    return t ? t.needs : ['x', 'y'];
}

export default CHART_TIPOS;
